import { useContext } from "react"
import { ProductPageDataQuery } from "@generated/graphql"
import { ACTION_TYPE, AppContext } from "AppContext"
import { StyledProductCard, StyledCardDiv, StyledProductCardImage, AddToCartButton } from "../styled/StyledProductCard"

interface Props {
  product: ProductPageDataQuery["newReleasedProducts"][0]
}

export default function ProductCard({ product }: Props) {
  const { state, dispatch } = useContext(AppContext)
  const imgSrc = product.featuredImage || "/assets/img/logo.png"
  return (
    <StyledProductCard>
      <StyledProductCardImage variant="top" src={imgSrc} />
      <StyledCardDiv>
        <div>
          {product?.age && <span style={{ fontSize: "1em" }}>Age: {product?.age}</span>}
          <span className="product-name">{product?.name}</span>
        </div>
        {!product?.age && <br />}
        <div>
          {`${product.price} coins`}
        </div>
        <div className="mt-2">
          <AddToCartButton onClick={() => {
            if (state.user === undefined) {
              dispatch({ type: ACTION_TYPE.SET_LOGIN_MODAL_VISIBLE, payload: true })
            } else {
              dispatch({
                type: ACTION_TYPE.SET_PRODUCT_CHECKOUT, payload: {
                  product: product
                }
              })
            }
          }}>
            Claim Reward
          </AddToCartButton>
        </div>
      </StyledCardDiv>
    </StyledProductCard>
  )
}
